import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';
import ApiTierOrderModal from './ApiTierOrderModal';
import { useModal } from 'components/modals/ModalContext';
import { useAuthContext } from 'services/authentication/AuthenticationContext';
import { useSettingsDivision } from 'components/settings/SettingsDivisionContext';
import { canOrderPaidFeatures } from '../billing/functions/billingUtils';

// Rename the name of the function:
const ApiKeyForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {
    const { initializeModal } = useModal();
    const { environmentType } = useAuthContext();

    // Prefill the division with the division selected in the settings menu
    const { selectedDivision, isEnvironmentSelected } = useSettingsDivision();
    const divisionDefaultValue = !isEnvironmentSelected && selectedDivision ? { value: String(selectedDivision.id) } : undefined;
    const apiObject = 'api_token'

    // Chain into the tier order modal after creating a new key, non ordering environment types keep the free tier
    const openTierOrderModal = (data?: Record<string, any>) => {
        if (!canOrderPaidFeatures(environmentType) || !data?.id) return;
        initializeModal(
            <ApiTierOrderModal tokenId={data.id} />,
            { modalSize: 'medium' }
        );
    };

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'api_key.general.name_label',
            type: 'text',
            placeholder: 'api_key.general.name_placeholder'
        },
        {
            name: 'division',
            defaultValue: divisionDefaultValue,
            label: 'api_key.general.division_label',
            type: 'dropdown',
            disabled_selected: 'api_key.general.select_division_disabled_selected',
            showSearch: false,
            apiRequest: [{
                endpoint: 'get_division_list',
                object: 'division',
                params: { is_active: true },
                useCache: true
            }],
            allowNoneOption: false,
            activeFeature: 'divisions',
            helperText: 'api_key.general.division_helperText'
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            onSuccess={openTierOrderModal}
        />
    );
};

export default ApiKeyForm;